export type Region = 'americas' | 'europe' | 'middle_east';

export interface OfficeLocation {
  region: Region;
  city: string;
  country: string;
  label: string;
  shortLabel: string;
}

export const OFFICES: Record<Region, OfficeLocation> = {
  americas: {
    region: 'americas',
    city: 'Wakefield',
    country: 'USA',
    label: 'Wakefield, MA, USA',
    shortLabel: 'Wakefield, MA',
  },
  europe: {
    region: 'europe',
    city: 'Belgrade',
    country: 'Serbia',
    label: 'Belgrade, Serbia',
    shortLabel: 'Belgrade, Serbia',
  },
  middle_east: {
    region: 'middle_east',
    city: 'Dubai',
    country: 'UAE',
    label: 'Dubai, UAE',
    shortLabel: 'Dubai, UAE',
  },
};

export const ALL_OFFICES = Object.values(OFFICES);

// Timezone-based region detection
const MIDDLE_EAST_TIMEZONES = [
  'Asia/Dubai', 'Asia/Muscat', 'Asia/Riyadh', 'Asia/Qatar', 'Asia/Bahrain',
  'Asia/Kuwait', 'Asia/Aden', 'Asia/Baghdad', 'Asia/Tehran', 'Asia/Jerusalem',
  'Asia/Amman', 'Asia/Beirut', 'Asia/Damascus', 'Africa/Cairo',
  'Asia/Nicosia', 'Europe/Istanbul',
];

const AMERICAS_PREFIXES = ['America/', 'US/', 'Canada/', 'Pacific/'];

export function detectRegion(): Region {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (MIDDLE_EAST_TIMEZONES.includes(tz)) {
      return 'middle_east';
    }

    if (AMERICAS_PREFIXES.some(prefix => tz.startsWith(prefix))) {
      return 'americas';
    }

    // Default remaining (Europe, Africa, Asia outside ME) → Europe office
    return 'europe';
  } catch {
    // Fallback if timezone detection fails
    return 'americas';
  }
}

export function getOfficeForRegion(region: Region): OfficeLocation {
  return OFFICES[region];
}

export function getUserOffice(): OfficeLocation {
  return OFFICES[detectRegion()];
}
